import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  public getImage(name: string) {
    return `/assets/images/${name}`
  }

  public getIcon(name: string) {
    return `/assets/icons/${name}`
  }

}
